import styled, { css } from "styled-components";

interface Props {
  additionsWidth: number;
  inputId: string;
}

export const InputContainer = styled.div<Props>`
  align-items: center;
  display: flex;
  flex-grow: 1;
  position: relative;
  ${({ inputId, additionsWidth }) => css`
    #${inputId} {
      padding-right: ${additionsWidth + 8}px;
    }
  `}
`;

export const Additions = styled.div`
  align-items: center;
  display: flex;
  position: absolute;
  right: 0;
  z-index: 1;
`;
